"use client"

import { startTransition, useEffect, useState } from "react"

export function ReadingProgress() {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const updateProgress = () => {
      const scrollTop = window.scrollY
      const docHeight = document.documentElement.scrollHeight - window.innerHeight
      const scrollPercent = (scrollTop / docHeight) * 100
      // startTransition: a sync setState from a scroll event during initial
      // hydration forces React to abandon not-yet-hydrated Suspense boundaries
      // (the dynamic() blog widgets) and client-render them, logging a
      // recoverable React #418 for nearly every early-scrolling blog reader
      // (~1k/month in PostHog). Marking the update non-urgent lets hydration
      // win the race; the bar visually lags by a frame at most.
      startTransition(() => setProgress(Math.min(scrollPercent, 100)))
    }

    window.addEventListener("scroll", updateProgress, { passive: true })
    updateProgress() // Initial calculation

    return () => window.removeEventListener("scroll", updateProgress)
  }, [])

  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[300] hidden h-[3px] md:block">
      <div
        className="h-full bg-linear-to-r from-green-600 to-emerald-600 transition-[width] duration-75 ease-linear [box-shadow:0_0_10px_rgba(22,163,74,0.6)]"
        style={{ width: `${progress}%` }}
      />
    </div>
  )
}
